import QRCode from "qrcode";

import { api } from "../../api/client";
import type { PairingResponse } from "../../types";
import { button, el } from "../atoms/dom";

export function pairingPage(onAuthenticated: (token: string) => void) {
  let active = true;
  let pairing: PairingResponse | null = null;
  let timer: number | null = null;

  const canvas = document.createElement("canvas");
  canvas.className = "pairing-card__qr";
  const status = el("p", {
    className: "pairing-status",
    text: "Güvenli QR kod hazırlanıyor…",
  });
  const refresh = button("Yeni QR kod oluştur", () => void create(), "quiet");
  refresh.hidden = true;

  const root = el(
    "main",
    { className: "pairing-page" },
    el(
      "section",
      { className: "pairing-card" },
      el(
        "div",
        { className: "pairing-card__brand" },
        el("div", { className: "brand__mark", text: "C2" }),
        el(
          "div",
          {},
          el("strong", { text: "Call2app Web" }),
          el("span", { text: "İşletme paneli" }),
        ),
      ),
      el(
        "div",
        { className: "pairing-card__content" },
        el(
          "div",
          { className: "pairing-copy" },
          el("span", { className: "eyebrow", text: "GÜVENLİ EŞLEŞTİRME" }),
          el("h1", { text: "Call2app'i bilgisayarınızda kullanın" }),
          el("p", {
            text: "Telefonunuzdaki hesabı bu tarayıcıya bağlamak için aşağıdaki adımları izleyin.",
          }),
          el(
            "ol",
            { className: "pairing-steps" },
            el("li", {}, el("b", { text: "1" }), "Call2app mobil uygulamasını açın."),
            el("li", {}, el("b", { text: "2" }), "Yönet > Web oturumları bölümüne girin."),
            el("li", {}, el("b", { text: "3" }), "Cihaz bağla ile bu QR kodu okutun."),
          ),
          el("p", {
            className: "pairing-note",
            text: "Telefon doğrulama ve onboarding işlemleri yalnızca mobil uygulamada yapılır.",
          }),
        ),
        el("div", { className: "pairing-card__visual" }, canvas, status, refresh),
      ),
    ),
    el("p", {
      className: "pairing-page__footer",
      text: "Uçtan uca güvenli oturum · Call2app",
    }),
  );

  async function create() {
    if (timer !== null) window.clearTimeout(timer);
    refresh.hidden = true;
    status.textContent = "Güvenli QR kod hazırlanıyor…";
    try {
      pairing = await api.createPairing(deviceName(), browserName());
      await QRCode.toCanvas(canvas, pairing.qrPayload, {
        width: 264,
        margin: 2,
        color: { dark: "#173a5e", light: "#ffffff" },
      });
      status.textContent = "Telefonunuzla QR kodu okutun";
      schedulePoll();
    } catch {
      status.textContent = "QR kod hazırlanamadı. İnternet bağlantınızı kontrol edin.";
      refresh.hidden = false;
    }
  }

  function schedulePoll() {
    timer = window.setTimeout(() => void poll(), 1400);
  }

  async function poll() {
    if (!active || !pairing) return;
    try {
      const result = await api.pairingStatus(pairing);
      if (result.status === "approved") {
        status.textContent = "Eşleştirme onaylandı, panel açılıyor…";
        const session = await api.exchangePairing(pairing);
        if (active) onAuthenticated(session.sessionToken);
        return;
      }
      if (result.status === "expired" || result.status === "consumed") {
        status.textContent = "QR kodun süresi doldu. Yeni bir kod oluşturun.";
        refresh.hidden = false;
        return;
      }
      schedulePoll();
    } catch {
      if (active) schedulePoll();
    }
  }

  void create();
  return {
    element: root,
    cleanup: () => {
      active = false;
      if (timer !== null) window.clearTimeout(timer);
    },
  };
}

function browserName() {
  const agent = navigator.userAgent;
  if (agent.includes("Edg/")) return "Microsoft Edge";
  if (agent.includes("Chrome/")) return "Google Chrome";
  if (agent.includes("Safari/")) return "Safari";
  if (agent.includes("Firefox/")) return "Firefox";
  return "Web tarayıcısı";
}

function deviceName() {
  const platform = (navigator as Navigator & {
    userAgentData?: { platform?: string };
  }).userAgentData?.platform ?? navigator.platform;
  return platform ? `${platform} bilgisayar` : "Bilgisayar";
}
